import React from 'react';
import { useRevealOnScroll } from '../hooks/useRevealOnScroll';
import './HomeInfo.css';

const HomeInfo = () => {
  useRevealOnScroll();
  
  return (
    <section className="home-info" id="home-info">
      <div className="home-info__inner">
        <img
          src="/img/nintschew_icon.png"
          alt="Nintschew Icon"
          className="home-info__icon"
        />

        <h2 className="home-info__headline reveal">
          <span className="home-info__headline-strong">Wir gestalten</span> <span>Zukunft</span>
        </h2>
        <p className="home-info__subheadline">mit Weitblick und Persönlichkeit.</p>

        <hr className="home-info__divider" />

        <div className="home-info__text">
          <p className="home-info__lead">
          Wir stehen für Steuerberatung, die strategisch gestaltet, unternehmerisch denkt und es klar auf den Punkt bringt – persönlich und auf Augenhöhe.
          </p>
        </div>

        <div className="home-info__kpis">
          <div className="home-info__kpi">
            <div className="home-info__kpi-number">150+</div>
            <div className="home-info__kpi-label">Zufriedene Mandanten</div>
          </div>
          <div className="home-info__kpi">
            <div className="home-info__kpi-number">150+ Mio. €</div>
            <div className="home-info__kpi-label">Betreutes Vermögen</div>
          </div>
          <div className="home-info__kpi">
            <div className="home-info__kpi-number">300+</div>
            <div className="home-info__kpi-label">Begleitete Transaktionen</div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default HomeInfo;


